// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.header {
  display: flex;
  justify-content: space-between;
  margin: 1em auto;
}
.header h3 {
  margin: 0;
}
@media screen and (max-width: 780px) {
  .header {
    align-items: flex-start;
    flex-direction: column-reverse;
  }
  .header .header-buttons {
    margin: 1rem 0;
  }
}

.copy-dialog {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem;
}
.copy-dialog button {
  width: 10rem;
}

.copy-dialog-partner {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
}

.btn-auto {
  margin: 2rem 1rem 0 0;
  width: auto !important;
}

::ng-deep .uniform-button,
::ng-deep .p-button.uniform-button,
::ng-deep .p-splitbutton.uniform-button {
  width: 160px !important;
  height: 40px !important;
}

::ng-deep .p-splitbutton.uniform-button .p-splitbutton-defaultbutton {
  width: calc(100% - 2rem) !important;
  height: 40px !important;
}

::ng-deep .p-splitbutton.uniform-button .p-splitbutton-menubutton {
  width: 2rem !important;
  height: 40px !important;
}

/* Fenêtre de transfert du fichier : avancement et annulation. */
.upload-dialog {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.upload-dialog-text {
  margin: 0;
  text-align: center;
}

.upload-dialog-actions {
  display: flex;
  justify-content: flex-end;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/etl-v1/etl/etl.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAEJ;AAAI;EACI,SAAA;AAER;AACI;EATJ;IAUQ,uBAAA;IACA,8BAAA;EAEN;EAAM;IACI,cAAA;EAEV;AACF;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACJ;AACI;EACI,YAAA;AACR;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,sBAAA;AAAJ;;AAGA;;;EAGE,uBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mCAAA;EACA,uBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,uBAAA;AAAF;;AAEA,gEAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;;AAEA;EACI,SAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;AACJ;AACA,4uFAA4uF","sourcesContent":[".header {\n    display: flex;\n    justify-content: space-between;\n    margin: 1em auto;\n\n    h3 {\n        margin: 0;\n    }\n\n    @media screen and (max-width: 780px) {\n        align-items: flex-start;\n        flex-direction: column-reverse;\n\n        .header-buttons {\n            margin: 1rem 0;\n        }\n    }\n}\n\n.copy-dialog {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin: 1rem;\n\n    button {\n        width: 10rem;\n    }\n}\n\n.copy-dialog-partner {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-top: 1rem;\n}\n\n.btn-auto {\n    margin: 2rem 1rem 0 0;\n    width: auto !important;\n}\n\n::ng-deep .uniform-button,\n::ng-deep .p-button.uniform-button,\n::ng-deep .p-splitbutton.uniform-button {\n  width: 160px !important;\n  height: 40px !important;\n}\n\n::ng-deep .p-splitbutton.uniform-button .p-splitbutton-defaultbutton {\n  width: calc(100% - 2rem) !important;\n  height: 40px !important;\n}\n\n::ng-deep .p-splitbutton.uniform-button .p-splitbutton-menubutton {\n  width: 2rem !important;\n  height: 40px !important;\n}\n/* Fenêtre de transfert du fichier : avancement et annulation. */\n.upload-dialog {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.upload-dialog-text {\n    margin: 0;\n    text-align: center;\n}\n\n.upload-dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
